<template>
    <NewButton
        data-test-id="DocumentViewButton"
        variant="link"
        color="neutral"
        :disabled="disable"
        @click="$emit('click', $event)"
    >
        <EidIcon
            class="text-base"
            :icon-src="iconViewDocument"
            alt="view document"
        />
        <span class="inline-block">View</span>
    </NewButton>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    import NewButton from '@/components/new-button/NewButton.vue';

    export default defineComponent({
        name: 'DocumentViewButton',
        components: { EidIcon, NewButton },
        props: {
            disable: {
                type: Boolean,
                default: false,
            },
        },
        emits: [ 'click' ],
        data() {
            return {
                iconViewDocument: faArrowUpRightFromSquare,
            };
        },
    });
</script>
